export default "__VITE_ASSET__DFo8j_f1__"